<template>
    <div>
        <!-- 登录 start -->
        <div class="login" v-show="loginTemplate">
             <img src="../../assets/image/login.png"></img>
             <div class="container-width login-container" >
               <div class="content">
                   <div class=" font-s36 c06">用户登记</div>
                        <div class="userinfo">
                            <el-row class="account">
                                <el-input placeholder="请输入手机号码" v-model="username" autofocus="autofocus">
                                    <i slot="prefix" class="el-input__icon el-icon-account el-icon-loginsize"></i>
                                </el-input>
                            </el-row>
                            <el-row class="pwd">
                                <el-input placeholder="请输入密码" v-model="pwd" @keyup.enter.native="login" type="password">
                                    <i slot="prefix" class="el-input__icon el-icon-pwd el-icon-loginsize"></i>
                                </el-input>
                            </el-row>
                            <el-row class="hint">
                                <img src="../../assets/image/hint.png" class="middle" v-if="hint!=''">
                                {{hint}}
                            </el-row>
                            <el-row class="operation">
                                <el-button class="el-long login-btn" :loading="loading" @click="login" >{{loading?'登 录 中':'登 录'}}</el-button>
                            </el-row>
                            <el-row class="other-operating">
                                <el-col :span="12">
                                    <div @click="register">没有账号？去注册</div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="text-right"  @click="findAccount">忘记密码？</div>
                                </el-col>
                            </el-row>
                        </div>
               </div>
             </div>
        </div>
        <!-- 登录 end -->
        <!-- <router-view/> -->
        <!-- 用户中心 模板  start -->
    <div style="background: #F4F4F4;">
        <div class="container-width" v-show="userTemplate">
            <div class="user-template" >
                 <!-- 路径 -->
                    <div class="crumb">
                        <template v-if="$route.meta.name" v-for="(item,index) in $route.meta.name">
                            <span v-html="item"></span>
                        </template>
                    </div>
                <div class="clearfix">
                    <div class="template-l fl">
                        <!-- menu start -->
                           <el-menu
                                :default-active="activeName"
                                class="el-menu-vertical-demo"
                                text-color=" #666666"
                                active-text-color=" #06c88c"
                                unique-opened
                                @select="handleSelect"
                            >
                                <div v-for="(item,index) of menuCenter" :key="index">
                                    <el-submenu :index="item.name" >
                                        <template slot="title">
                                            <i :class="item.icon"></i>
                                            <span>{{item.name}}</span>
                                        </template>
                                        <el-menu-item
                                            v-for="(item,index) of item.children"
                                            :index="item.userSign"
                                            :key="index"
                                        >
                                         <router-link  :to="item.link">{{item.name}}</router-link>
                                        </el-menu-item>
                                    </el-submenu>
                                </div>
                            </el-menu>
                        <!-- menu end -->
                    </div>
                    <div class="template-r fr">
                       <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
      </div>
        <!-- 用户中心 模板  end -->
    </div>
</template>

<script>
import { Login } from "../../api/api";
import { IsLogin } from "../../api/api";

export default {
  data() {
    return {
      //    item值
      //    from从哪个页面转入   userCenter个人中心
      userName: sessionStorage.getItem("username"),
      item:
        this.$route.query.item == undefined
          ? ""
          : JSON.parse(this.$route.query.item),
      activeName: "user",
      loading: false,
      username: "", //账户
      pwd: "", //密码
      hint: "",
      loginTemplate: false, //登录
      userTemplate: false, //模板
      menuCenter: [
        {
          name: "用户管理",
          link: "",
          icon: "el-icon el-iconsize icon-manage",
          children: [
            {
              name: "我的服务",
              link: "/userCenter/myTest",
              userSign: "user"
            }
          ]
        },
        {
          name: "个人中心",
          link: "",
          icon: "el-icon el-iconsize icon-user",
          children: [
            {
              name: "账户信息",
              link: "/userCenter/accountInfo",
              userSign: "userInfo"
            },
            {
              name: "账户充值",
              link: "/userCenter/price",
              userSign: "pay"
            }
          ]
        }
      ]
    };
  },

  watch: {
    $route(to, from) {
      this.menuSave();
    }
  },
  created() {
    this.$axios.post(IsLogin, {}).then(res => {
      if (res.data == false) {
        this.loginTemplate = true;
        this.userTemplate = false;
      } else {
        this.loginTemplate = false;
        this.userTemplate = true;
      }
    });
  },
  mounted() {
    this.menuSave();
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeName = key;
    },
    menuSave() {
      this.activeName = this.$route.meta.userSign;
    },
    login() {
      var checkPhone = /^[0-9]{11}$/;
      if (this.username == "" || checkPhone.test(this.username) == false) {
        this.hint = "请输入正确的手机号码";
      } else if (this.pwd == "") {
        this.hint = "请输入密码";
      } else {
        this.hint = "";
        var db = {
          telphone: this.username, //	手机号
          password: this.pwd //	密码
        };
        this.$axios.post(Login, db).then(
          res => {
            this.loading = true;
            if (res.data.code == 1) {
              //   成功，进入页面
              let username = res.data.data.userid; //账户
              sessionStorage.setItem("username", JSON.stringify(username));
              if(this.item==''){
                  this.$router.push("/");
              }
              else{
                if (this.item.from == "userCenter") {
                    this.$router.push("/");
                } else {
                    this.$router.push({ name: this.item.from ,query:{item:JSON.stringify(this.item)}});
                }
              }
              this.loading = false;
            } else {
              this.loading = false;
              this.pwd = "";
              this.hint = res.data.msg;
            }
          },
          err => {
            this.loading = false;
            this.$message.error(err.data.msg);
          }
        );
      }
    },
    register() {
      //注册账号
      var from;
      if (this.item == "") {
        from = "userCenter";
      } else {
        from = this.item.from;
      }
      var item = {
        telphone: this.username, //手机号码
        from: from, //从哪个页面转入
        id:this.item.id,
        type:this.item.type
      };
      this.$router.push({
        name: "register",
        query: { item: JSON.stringify(item) }
      });
    },
    findAccount() {
      //找回密码
      sessionStorage.removeItem("username");
      var from;
      if (this.item == "") {
        from = "userCenter";
      } else {
        from = this.item.from;
      }
      var item = {
        telphone: this.username, //手机号码
        from: from, //从哪个页面转入
        id:this.item.id,
        type:this.item.type
      };
      this.$router.push({
        name: "findAccount",
        query: { item: JSON.stringify(item) }
      });
    }
  }
};
</script>

<style lang="scss">
.login > img {
  width: 100%;
  min-height: 550px;
  display: block;
}
.login {
//   background: #333;
  position: relative;
  .login-container {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  .content {
    position: absolute;
    right: 0;
    top: 71px;
    padding: 50px;
    background: #ffffff;
    box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    width: 400px;
    .userinfo {
      padding-top: 50px;
      .el-icon-loginsize {
        -webkit-background-size: 20px 20px;
        background-size: 20px 20px;
        margin-top: 8px;
        margin-right: 15.5px;
      }
      .account {
        .el-icon-account {
          background: url("../../assets/image/account.png") 0 0 no-repeat;
        }
        border-bottom: 1px #f4f4f4 solid;
      }
      .pwd {
        .el-icon-pwd {
          background: url("../../assets/image/pwd.png") 0 0 no-repeat;
        }
        padding-top: 15px;
        border-bottom: 1px #f4f4f4 solid;
      }
      .el-input--prefix .el-input__inner {
        padding-left: 35.5px;
        font-size: 18px;
        color: #999999;
        border: none;
      }
      .hint {
        font-size: 12px;
        color: #f5a623;
        height: 40px;
        padding-top: 5px;
      }
      .operation {
        .login-btn {
          background: #06c88c;
          border-radius: 2px;
          font-size: 16px;
          color: #ffffff;
          height: 50px;

          border: none;
        }
      }
      .other-operating {
        padding-top: 6px;
        font-size: 14px;
        color: #999999;
        cursor: pointer;
      }
    }
  }
}
.user-template {
  padding: 60px 0;
  .crumb {
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    padding-bottom: 10px;
  }
  .crumb span:after {
    content: "/";
    margin: 0 5px;
    font-weight: normal !important;
    color: #999999 !important;
  }
  .crumb span:last-child:after {
    display: none;
  }
  .template-l {
    width: 220px;
    min-height: 480px;
    background: #ffffff;
    .el-icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 6px;
      width: 18px;
      height: 18px;
    }
    .el-iconsize {
      -webkit-background-size: 18px 18px;
      background-size: 18px 18px;
    }
    .icon-manage {
      //用户管理
      background: url("../../assets/image/userManage.png") 0 0 no-repeat;
    }
    .icon-user {
      //个人中心
      background: url("../../assets/image/userCenter.png") 0 0 no-repeat;
    }
    //   一级颜色
    .el-submenu__title {
      font-size: 18px;
      color: #333333;
    }
    //   导航选中
    .el-menu {
      border-right: none;
    }
    .el-menu-item {
      border-left: 4px transparent solid;
      a {
        color: #999999;
        display: block;
      }
    }
    .el-menu-item.is-active {
      background: #f4f4f4;
      border-left-color: #06c88c;
    }
    .el-menu-item.is-active a {
      color: #06c88c;
    }
  }
  .template-r {
    width: 740px;
    min-height: 480px;
    background: #ffffff;
  }
}
</style>
